import {useState} from "react";
import {RegionSlug} from "src/store/types";

import {useEffectAsync} from "../components/_common/Carbon";
import {PricingTierItem, usePricingData} from "../utils/fetchPricingData";
import {getPricingTierByRegionSlug} from "../utils/getPricingTierBySlug";
import {useUserSelectedLocation} from "../utils/browser-storage/userSelectedLocation";

export const usePricesByRegion = (regionSlug?: string): PricingTierItem[] => {
  const [prices, setPrices] = useState<PricingTierItem[]>([]);
  const regionPricing = usePricingData();
  const {regionSlug: selectedRegion} = useUserSelectedLocation();
  const slugToCheck = regionSlug || selectedRegion;

  useEffectAsync(async () => {
    if (!regionPricing) return;
    const priceTier = getPricingTierByRegionSlug(slugToCheck as RegionSlug);
    setPrices(regionPricing[priceTier]);
  }, [selectedRegion, regionSlug, regionPricing]);

  return prices;
};
